import { render } from "./IdeaPolicyView.vue?vue&type=template&id=b277e6e8"
import script from "./IdeaPolicyView.vue?vue&type=script&lang=js"
export * from "./IdeaPolicyView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__